export default __webpack_public_path__ + "static/media/outside_AQP-OUTDOOR-12,5-MM-SPSTROP.e3b43122.jpg";